import { notification } from 'antd'
import { useMutation } from 'react-query'
import { authenticateToTenant, forgotPassword, resetPassword, signIn, signOut } from './authenticationApi'

type SignInParams = {
  username: string
  password: string
}

export const useSignInMutation = () => {
  return useMutation({
    mutationFn: ({ username, password }: SignInParams) => {
      return signIn(username, password)
    }
  })
}

export const useSignOutMutation = () => {
  return useMutation({
    mutationFn: signOut,
  })
}

export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationFn: (email: string) => {
      return forgotPassword(email)
    }
  })
}

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: (params: { email: string, token: string, password: string }) => {
      return resetPassword(params.email, params.token, params.password)
    }
  })
}

export const useAuthenticateToTenant = () => {
  return useMutation({
    mutationFn: (tenantId: number) => authenticateToTenant(tenantId),
    onSuccess: x => {
      localStorage.setItem('synkedup_token', JSON.stringify(x))
      window.location.href = '/#!/'
      window.location.reload()
    },
    onError: () => {
      notification.error({message: 'There was an error authenticating to the tenant. Please try again later.'})
    }
  })
}